import { configureStore } from '@reduxjs/toolkit'
import authReducer from '../services/auth/authSlice'
import botReducer from '../services/bot/botSlice'
import sidebarReducer from '../app/chat/sidebar/sidebarSlice'
import layoutReducer from '../services/layout/layoutSlice'

export default configureStore({
    reducer: {
        bot: botReducer,
        auth: authReducer,
        sidebar: sidebarReducer,
        layout: layoutReducer
    }
})